// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EaC5","col":"styles_col__1mmzp","actions":"styles_actions__2IDoB","conflict":"styles_conflict__3y32M"};